import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Nevada = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Nevada Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Disclosure statement required at least 10 days before closing.
        </Text>

        <Text style={styles.listItem}>
          2. Seller's Real Property Disclosure: Mandatory.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          4.{' '}
          <Text style={styles.underline}>
            Seller's Real Property Disclosure Form
          </Text>{' '}
          – Nevada requires property sellers to provide buyers with an
          accounting of the property's condition at least 10 days before
          transferring ownership.
        </Text>
      </View>
    </View>
  );
};

export default Nevada;
